export default "__VITE_ASSET__DYWy0CcT__"